export enum AlertTypeEnum {
  Danger = 'danger',
  Warning = 'warning',
  Info = 'info'
}
